import React, { Component } from "react";
import styled from "styled-components";

import baseStyles from "../../styles/baseStyles";
import FilterLabel from "./FilterLabel";

const Container = styled.div`
  border-bottom: 1px solid ${baseStyles.color.black.o50};
  margin-bottom: 3rem;
  padding-bottom: 1rem;
  min-width: 0;
  flex: none;
  @media screen and (max-width: 425px) {
    overflow-x: scroll;
  }
`;

const LabelList = styled.ul`
  display: flex;
  padding: 0;
  margin: 0;
`;

class FilterBar extends Component {
  state = {
    filters: {}
  };
  componentDidMount() {
    const jobs = this.props.jobs;
    // Replace this potentially by recursion
    const filters = {
      options: this.props.filterBy.map(({ label, key }) => {
        return {
          label,
          options: Array.from(new Set(jobs.map(job => job[key]))).map(
            label => ({ label, selected: true })
          ),
          selected: true
        };
      })
    };

    this.setState({ filters });
  }

  onCheckboxChanged = (label, category) => {
    // Replace this potentially by recursion
    const changedLabelIndex = this.state.filters.options
      .map(option => option.label)
      .indexOf(category);
    const changedOptionIndex = this.state.filters.options[
      changedLabelIndex
    ].options
      .map(option => option.label)
      .indexOf(label);

    let newFilters = Object.assign({}, this.state.filters);

    newFilters.options[changedLabelIndex].options[
      changedOptionIndex
    ].selected = !newFilters.options[changedLabelIndex].options[
      changedOptionIndex
    ].selected;

    this.setState({ filters: newFilters });
    this.props.filterList(this.state.filters);
  };

  onSelectAll = label => {
    const changedLabelIndex = this.state.filters.options
      .map(option => option.label)
      .indexOf(label);

    let newFilters = Object.assign({}, this.state.filters);

    newFilters.options[changedLabelIndex].options = newFilters.options[
      changedLabelIndex
    ].options.map(option => ({
      label: option.label,
      selected: !this.state.filters.options[changedLabelIndex].selected
    }));

    newFilters.options[changedLabelIndex].selected = !newFilters.options[
      changedLabelIndex
    ].selected;

    this.setState(prevState => ({ ...prevState, filters: newFilters }));
    this.props.filterList(this.state.filters);
  };

  filterLabels() {
    if (this.state.filters.options) {
      return this.state.filters.options.map(({ label, options, selected }) => {
        return (
          <FilterLabel
            key={label}
            label={label}
            selectedAll={selected}
            options={options}
            onCheckboxChanged={(label, category) =>
              this.onCheckboxChanged(label, category)
            }
            onSelectAll={label => this.onSelectAll(label)}
          />
        );
      });
    }
  }
  render() {
    return (
      <Container>
        {this.state.filters ? (
          <LabelList>{this.filterLabels()}</LabelList>
        ) : null}
      </Container>
    );
  }
}

export default FilterBar;



// WEBPACK FOOTER //
// ./src/components/FilterBar/index.js